// 饼图（6 类以内，扇区可点击）
import { useMemo } from 'react'
import ReactECharts from 'echarts-for-react'
import type { EChartsOption } from 'echarts'
import { formatNumber } from '@/lib/utils'
import { WX_PALETTE } from '@/lib/chartTheme'
import { wechatTheme } from '@/lib/theme'

export interface PieDatum {
  name: string
  value: number
}

interface Props {
  data: PieDatum[]
  centerText?: string
  height?: number
  onItemClick?: (name: string) => void
  className?: string
}

const PALETTE = WX_PALETTE

export default function PieChart({ data, centerText, height = 280, onItemClick, className }: Props) {
  const option = useMemo<EChartsOption>(() => {
    return {
      tooltip: {
        trigger: 'item',
        backgroundColor: wechatTheme.bg.card,
        borderColor: wechatTheme.border.DEFAULT,
        textStyle: { color: wechatTheme.text.primary, fontSize: 12 },
        formatter: (p: any) =>
          `<div style="font-weight:600">${p.name}</div>
           <div>${formatNumber(p.value)} (${p.percent}%)</div>`,
      },
      legend: {
        orient: 'vertical',
        right: 8,
        top: 'middle',
        icon: 'circle',
        itemWidth: 10,
        itemHeight: 10,
        textStyle: { color: wechatTheme.text.tertiary, fontSize: 12 },
        formatter: (name: string) => {
          const item = data.find((d) => d.name === name)
          return `${name}  ${item ? formatNumber(item.value) : ''}`
        },
      },
      color: PALETTE,
      series: [
        {
          type: 'pie',
          radius: ['55%', '80%'],
          center: ['38%', '50%'],
          avoidLabelOverlap: true,
          itemStyle: { 
            borderColor: wechatTheme.bg.card, 
            borderWidth: 3, 
            borderRadius: 4,
            shadowBlur: 10,
            shadowColor: 'rgba(0,0,0,0.08)',
          },
          label: { show: false },
          labelLine: { show: false },
          emphasis: { 
            scale: true, 
            scaleSize: 6,
            itemStyle: { 
              shadowBlur: 20,
              shadowColor: 'rgba(0,0,0,0.15)',
            },
          },
          data: data.map((d) => ({ name: d.name, value: d.value })),
        },
      ],
      graphic: centerText
        ? [
            {
              type: 'text',
              left: '38%',
              top: '46%',
              style: { 
                text: centerText, 
                textAlign: 'center', 
                fill: wechatTheme.text.primary, 
                fontSize: 18, 
                fontWeight: 700,
                textShadow: '0 2px 4px rgba(0,0,0,0.1)',
              },
            },
          ]
        : undefined,
    }
  }, [data, centerText])

  return (
    <div className={className}>
      <ReactECharts
        option={option}
        style={{ height, width: '100%' }}
        notMerge
        lazyUpdate
        opts={{ renderer: 'canvas' }}
        onEvents={
          onItemClick
            ? {
                click: (params: any) => {
                  if (params.componentType === 'series') onItemClick(params.name)
                },
              }
            : undefined
        }
      />
    </div>
  )
}
